import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import Button from 'raydiant-elements/core/Button';
import Heading from 'raydiant-elements/core/Heading';
import Spacer from 'raydiant-elements/layout/Spacer';
import Text from 'raydiant-elements/typography/Text';
import useStyles from './DeleteConfirmationModal.styles';

interface DeleteConfirmationModalProps {
  open: boolean;
  handleClose: () => void;
  handleClick: () => void;
}

const DeleteConfirmationModal = ({
  open,
  handleClose,
  handleClick,
}: DeleteConfirmationModalProps) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <Heading className={classes.heading}>
          Confirm integration removal
        </Heading>
        <DialogContentText id="alert-dialog-description">
          <Text>
            Are you sure you want to remove this integration? You will no longer
            be able to view sales and location data in your Analytics dashboard.
          </Text>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          className={classes.button}
          onClick={handleClose}
          color="default"
        >
          Cancel
        </Button>
        <Spacer />
        <Button
          className={classes.button}
          onClick={handleClick}
          color="primary"
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
